<template>
  <a-modal :title="name" :visible="visible" width="95%" style="height: 95%" @cancel="handleOk">
    <template slot="footer">
      <a-button key="submit" type="primary" @click="handleOk">
        {{ $t('ok') }}
      </a-button>
    </template>
    <textarea class="txt-content" v-model="content" disabled></textarea>
  </a-modal>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleOk() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .ant-modal-body {
  min-height: 680px;
  height: 680px;
  overflow-y: auto;
  .txt-content {
    width: 100%;
    height: calc(100% - 48px);
    margin-top: 8px;
  }
}
</style>
